module.exports = __webpack_public_path__ + "static/media/dummyImage.0822b25f.svg";